// extracted by mini-css-extract-plugin
export default {"cellMarkdown":"CompareItemsModal_cellMarkdown__JgBFq","emptyCell":"CompareItemsModal_emptyCell__Wqwxc"};